module.exports = __webpack_public_path__ + "static/media/property-managers-6.2a67e462.svg";